import { format as originalFormat } from 'date-fns';

export const mapMomentToDateFns = (momentFormat: string): string => {
    // replacements for Moment.js format to date-fns format
    const replacements = [
        { regex: /YYYY/g, replacement: 'yyyy' },
        { regex: /YY/g, replacement: 'yy' },
        { regex: /DD/g, replacement: 'dd' },
        { regex: /D/g, replacement: 'd' },
    ];

    return replacements.reduce((formattedString, { regex, replacement }) => formattedString.replace(regex, replacement), momentFormat);
};

//TODO: once the backend is updated to send date-fns compatible format strings, this function can be removed.
// Wrapper function to convert Moment.js format to date-fns and format the date
export const format = (date, format, options = {}) => {
    // Convert Moment.js format to date-fns compatible format
    // Backend still sends Moment.js format strings, so we convert them to ensure compatibility with date-fns.
    // this is a workaround until the backend is updated to send date-fns compatible format strings.
    const dateFnsFormat = mapMomentToDateFns(format);

    // Format the date using date-fns with the converted format and additional options
    // The spread operator allows passing extra settings like locale if needed.
    // id the format is invalid, return the original format string
    try {
        return originalFormat(date, dateFnsFormat, { ...options });
    } catch (error) {
        return format;
    }
};

export const dateIsEqual = (currentDate: Date, compareDate: Date) => {
    // Set both dates to midnight to ignore time portion
    const current = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const compare = new Date(compareDate.getFullYear(), compareDate.getMonth(), compareDate.getDate());

    return current.getTime() === compare.getTime();
};

export const isBeforeOrEqualDate = (currentDate: Date, compareDate: Date): boolean => {
    // Set both dates to midnight to ignore time portion
    const current = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const compare = new Date(compareDate.getFullYear(), compareDate.getMonth(), compareDate.getDate());

    return current.getTime() <= compare.getTime();
};

export const isBeforeDate = (currentDate: Date, compareDate: Date): boolean => {
    // Set both dates to midnight to ignore time portion
    const current = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const compare = new Date(compareDate.getFullYear(), compareDate.getMonth(), compareDate.getDate());

    return current.getTime() < compare.getTime();
};

export const isAfterDate = (currentDate: Date, compareDate: Date): boolean => {
    // Set both dates to midnight to ignore time portion
    const current = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const compare = new Date(compareDate.getFullYear(), compareDate.getMonth(), compareDate.getDate());

    return current.getTime() > compare.getTime();
};

export const isAfterOrEqualDate = (currentDate: Date, compareDate: Date): boolean => {
    // Set both dates to midnight to ignore time portion
    const current = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const compare = new Date(compareDate.getFullYear(), compareDate.getMonth(), compareDate.getDate());

    return current.getTime() >= compare.getTime();
};
